export default "__VITE_ASSET__CWF$qAmR__"